import React from 'react';
import './Card.css';

function TarotCard({ card, onClick }) {
  return (
    <div
      className="fortune-card tarot"
      style={{ borderColor: card.color }}
      onClick={() => onClick(card)}
    >
      <div className="card-number">{card.id}</div>
      <div className="card-emoji" style={{ color: card.color }}>
        {card.emoji}
      </div>
      <h3 className="card-title">{card.kr}</h3>
      <p className="card-subtitle">{card.name}</p>
    </div>
  );
}

export default TarotCard;
